
import * as actionTypes from './actionTypes';

export const resetManagedState = () => {
  return {
    type: actionTypes.RESET_MANAGED_STATE,
    
  };
}
export const initManagedStart = () => {
  return {
    type: actionTypes.INIT_MANAGED_START
  };
};
export const refreshManaged = () => {
  return window.location.reload();
};
export const setManaged = (realManaged) => {
  return {
    type: actionTypes.SET_MANAGED,
    realManaged:realManaged
  };
};

export const fetchManagedFailed = () => {
  return {
    type: actionTypes.FETCH_MANAGED_FAILED
  };
};

export const initManaged = () => {
  return {
    type: actionTypes.INIT_MANAGED
  };
};


